import * as React from "react";

function SvgAsayer(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M22.13 10.831c.45 1.211.674 2.516.674 3.913v9.225c0 .513-.181.946-.544 1.297a1.754 1.754 0 01-1.287.548h-.06c-.497 0-.927-.183-1.289-.548a1.737 1.737 0 01-.543-1.297v-.933c-2.08 1.852-4.501 2.778-7.265 2.778-3.032 0-5.622-1.082-7.768-3.244C1.9 20.407.828 17.799.828 14.744c0-3.055 1.073-5.663 3.22-7.826 2.146-2.162 4.736-3.243 7.768-3.243 2.54 0 4.771.759 6.69 2.278l-2.905 2.905c-1.056-.598-2.24-.897-3.555-.897-2.004 0-3.714.696-5.13 2.087-1.404 1.39-2.105 3.064-2.105 5.019 0 1.968.701 3.648 2.104 5.039 1.417 1.377 3.127 2.066 5.131 2.066 2.004 0 3.708-.689 5.11-2.066 1.417-1.391 2.125-3.071 2.125-5.04 0-.44-.036-.866-.108-1.278l2.957-2.957z"
          fill="#3EAAAF"
        />
        <path
          d="M9.577 13.586a1.51 1.51 0 00-2.107.037 1.443 1.443 0 00.036 2.069l3.176 3.012a1.51 1.51 0 002.107-.037L27.164 3.133a1.44 1.44 0 00-.036-2.069 1.5 1.5 0 00-1.061-.41 1.5 1.5 0 00-1.046.447L11.684 15.584l-2.107-1.998z"
          fill="#42AE5E"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAsayer);
